import React, { useContext, useRef } from 'react';
import _get from 'lodash/get';

import { Notes } from 'components';
import { RetexContext } from 'components/RetexDetails';
import { getAllowedStatusMapForDelete } from './methods';

export default function RetexNotes() {
  const { retex, isProcessing: isDisabled } = useContext(RetexContext);
  const statusMapForDelete = useRef(getAllowedStatusMapForDelete()).current;

  const id = _get(retex, 'id', '');
  const status = _get(retex, 'status', '');
  const isCreatable = status !== 'AWAITING_COMPLETION';
  const isDeletable = _get(statusMapForDelete, status, false);

  return (
    <Notes.Provider
      type="RETEX"
      id={id}
      isDisabled={isDisabled}
      isCreatable={isCreatable}
      isDeletable={isDeletable}
    >
      <Notes.Container>
        <Notes.Form />
        <Notes.List />
      </Notes.Container>
    </Notes.Provider>
  );
}
